import set from 'lodash/set';
import { track } from '../helpers/tracking';
import { TrackingEvents } from '../common/models';

const waitAndExecute = (name, func) => {
  let fdElem = document.getElementById(name);
  if (fdElem) {
    func(fdElem);
  } else {
    const interval = setInterval(() => {
      fdElem = document.getElementById(name);
      if (fdElem) {
        func(fdElem);
        clearInterval(interval);
      }
    }, 250);
  }
};

const sendFdTrackingEvent = () => {
  waitAndExecute('lc_chat_layout', layout => {
    waitAndExecute('lc_prechat_submit', fdSubmit => {
      fdSubmit.addEventListener('click', () => {
        const name = document.getElementById('lc_chat_name').value;
        const email = document.getElementById('lc_chat_email').value;
        track(TrackingEvents.freshDeskStart(), { user: { name, email } });
      });
    });
  });
};

const fdStyleChange = (property, value, removeProperty) => {
  waitAndExecute('lc_chat_layout', fdElem => {
    if (property) {
      set(fdElem.style, property, value);
    }
    if (removeProperty) {
      set(fdElem.style, removeProperty, null);
    }
  });
};

const fdSet = () => {
  window.addEventListener('resize', () => {
    fdUpdateStyle();
  });

  fdUpdateStyle();

  waitAndExecute('lc_chat_header', fdElem => {
    fdElem.onclick = fdUpdateStyle;
  });
};

const getFdChatOpen = () => {
  let fdElem = document.getElementById('lc_chat_layout');
  if (fdElem && fdElem.classList && fdElem.classList.contains('lc-expanded')) {
    return true;
  }
  return false;
};

const fdUpdateStyle = () => {
  const isChatOpen = getFdChatOpen();
  if (window.innerWidth < 1024) {
    //mobile
    if (isChatOpen) {
      if (window.innerWidth < 721) fdStyleChange('left', '0px', 'right');
      else {
        fdStyleChange('left', '30px', 'right');
      }

      fdStyleChange(null, null, 'height');
    } else {
      fdStyleChange('left', '30px', 'right');
      fdStyleChange('height', '43px', null);
    }
  } else {
    if (isChatOpen) {
      //desktop
      fdStyleChange('right', '30px', 'left');
      fdStyleChange('height', '393px', null);
    } else {
      fdStyleChange('right', '30px', 'left');
      fdStyleChange('height', '43px', null);
    }
  }
};

export { fdSet, fdStyleChange, sendFdTrackingEvent };
